import { render, staticRenderFns } from "./Parrainage.vue?vue&type=template&id=acfbfb46"
import script from "./Parrainage.vue?vue&type=script&lang=js"
export * from "./Parrainage.vue?vue&type=script&lang=js"
import style0 from "./Parrainage.vue?vue&type=style&index=0&id=acfbfb46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports